import React, { Component } from "react";
import { Line } from "react-chartjs-2";
import moment from "moment";
import { ChartData, ChartOptions } from "chart.js";

export interface StrengthProgressionChartProps {
    strengthGraphData: StrengthGraphData | any;
}

export interface StrengthGraphData {
    labels: string[];
    datasets: {
        label: string;
        data: number[];
        borderColor: string;
        backgroundColor: string;
        fill: boolean;
    }[];
}

const strengthGraphOptions: ChartOptions<"line"> = {
    responsive: true,
    plugins: {
        title: {
            display: false
        }
    },
    scales: {
        x: {
            type: 'time',
            time: {
                displayFormats: {
                    day: 'MMM D'
                }
            }
        },
        y: {
            beginAtZero: true
        }
    }
};

class StrengthProgressionChart extends Component<StrengthProgressionChartProps> {
    render() {
        const { strengthGraphData } = this.props;
        
        const chartData: ChartData<"line"> = {
            labels: strengthGraphData.labels,
            datasets: strengthGraphData.datasets
        };

        return (
            <div>
                <Line data={chartData} options={strengthGraphOptions} />
            </div>
        );
    }
}

export default StrengthProgressionChart;
